import React from "react";
import PerosnalData from "./content";

const PerosnalDataPage = () => {
	return <PerosnalData/>;
};

export default PerosnalDataPage;
